export default __webpack_public_path__ + "static/media/benefit2.bf5d546e.png";